.optionBoxWrapper {
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	border: 1px solid #e8e8e8;
	background-color: #ffffff;
	border-radius: 10px;
	padding: 1rem;
	gap: 1rem;
	box-sizing: border-box;
}

.optionBlock {
	grid-template-columns: 40px 1fr auto;
	column-gap: 1rem;
	row-gap: 1rem;
	width: 100%;
	align-items: start;
	display: grid;
}

.menuItemsWrapper {
	width: 100%;
	grid-column: 2 / -1;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.infoArea {
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: flex-start;
	justify-content: center;
	width: 100%;
	min-width: 0;
}

.optionBlockCol {
	display: flex;
	flex-direction: column;
	gap: 0;
	align-items: flex-start;
	width: 100%;
	min-width: 0;
	grid-column: 2;
}

.optionTitleWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.625rem;
	align-items: center;

	& .optionTitleText:global(.MuiTypography-root) {
		font-size: 0.875rem;
		font-weight: 500;
		text-align: left;
		color: #262626;
		line-height: 20px;
	}

	&.disabled .optionTitleText:global(.MuiTypography-root) {
		color: #6f6f6f;
	}
}

.optionDescriptionText:global(.MuiTypography-root) {
	font-size: 0.875rem;
	font-weight: 400;
	text-align: left;
	line-height: 20px;
	color: #525252;
}

.optionDescriptionText a {
	white-space: nowrap;
}

.iconContainer {
	width: 40px;
	height: 40px;
}

.infoTextContainer {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	max-width: 220px;
	height: 100%;
	min-height: 58px;
}

.infoText:global(.MuiTypography-root) {
	font-size: 0.875rem;
	color: white;
	margin: 0;
	padding: 5px 2px;
	line-height: 1.6;
	padding: 0.625rem;
}

.infoText p + p {
	margin-top: 10px;
}

.disabled {
	color: #767676;
}

.platformBadge:global(.MuiChip-root) {
	min-width: fit-content;

	& span {
		font-size: 0.75rem;
	}
}

@media (max-width: 768px) {
	.optionBoxWrapper {
		padding: 0.5rem;
	}
	.optionBlock {
		padding-left: 0px;
	}

	.infoArea {
		padding-left: 0px;
	}

	.optionDescriptionText:global(.MuiTypography-root) {
		grid-column: -1/2;
	}

	.menuItemsWrapper {
		grid-column: -1/1;
	}

	.optionTitleWrapper {
		flex-direction: column;
		align-items: flex-start;
	}
}
